exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-icon[data-v-468900cd] {\n    font-size:1.5em;\n    z-index:10000;\n    position:absolute;\n    top:0.14em;\n    right:1em;\n    color:#a0a0a0;\n\n    /*cursor:pointer;*/\n}\n.search-icon-active[data-v-468900cd] {\n    color:#4FBE2B;\n}\n", ""]);

// exports
